import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors'

@Component({
  selector: 'landing-screen',
  templateUrl: 'landing-screen.html',
  styleUrls: ['landing-screen.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LandingScreenComponent {
  constructor(private store: Store<fromRoot.AppState>) {}
}
